import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41ab689e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("导出成本")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("同步公司")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("同步是否为内部译员")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("修改财务日期")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("是否计算")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("手动同步")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("颜色含义")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("表格颜色")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean manualRow" }, "手动调整", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_15 = { style: {"lineHeight":"35px"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确定")

import { ref, onBeforeMount, onActivated, computed } from 'vue'
import { ElMessage, ElMessageBox, rowProps } from 'element-plus'
import tbMix, { orgCfig } from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { categorysFunc } from '@/views/typeMapping/OrderMap'
import { formatTime, formatNumber, exportHandle } from '@/utils/index'
import Api from '@/http/modules/index'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  props: {
  readTableOnly: {
    type: Boolean,
    default: false
  },
},
  setup(__props, { expose }) {

const props = __props

let {paymentCompany, currencyOption}=PaymentModuleUtils
let {
  // 成本条件查询
  'POST/rt/query': fetchList,
  // 删除
  'DELETE/rt': rtDelApi,
  // 添加
  'POST/rt': rtAddApi,
  // 修改
  'PATCH/rt': rtModifyApi,
  // 同步所有公司
  'GET/rt/sync_company': rtSyncCompanyApi,
  'PATCH/rt/batch':rtBatchApi,
  // RT_不计算
  'PATCH/rt/calculated': calculatedApi,
  // RT导出
  'POST/rt/export': exportApi,
  // 同步是否为内部译员
  'PUT/rt/update_is_ccjk_user': update_is_ccjk_userApi,
  // 成本_导入不计算表
  'POST/rt/import_no_calculated': import_no_calculatedApi,
  // /rt/company/list
  'GET/rt/company/list': rtCompanyListApi,
  // 手动同步
  'PUT/rt/sync_rt': sync_rtApi,
  // 发票主体公司列表
  'GET/companies/en_name/{companyId}': companiesEn_nameApi,
  // 发票主体全部公司列表
  'GET/companies/en_name/list': companiesFullEn_nameApi,
  // 订单类别下拉框
  'GET/order_categorys/list': order_categorysListApi,
  // rt导入(临时)
  'POST/rt/import': rtImportApi,
} = Api



const route = useRoute()
const showTimeVisiable=ref<boolean>(false)
let loading=ref(false)
const paymentTime=ref("")
const idList=ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height 
} = new tbMix(fetchList)

let rtComapny= ref<object[]>([])
let invoiceCompanyList = ref([])
let orderCategorysOption: any = ref([])
const searchConfig = ref([
  {
    type: "TIME",
    label: "创建开始时间",
    value: '',
    upKey: 'dateCreatedFrom',
    props: {
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    type: "TIME",
    label: "创建结束时间",
    value: '',
    upKey: 'dateCreatedTo',
    props: {
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    type: "TIME",
    label: "余额开始时间",
    value: '',
    upKey: 'paymentTimeFrom',
    props: {
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    type: "TIME",
    label: "余额结束时间",
    value: '',
    upKey: 'paymentTimeTo',
    props: {
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    type: "TIME",
    label: "完工开始时间",
    value: '',
    upKey: 'deliverTimeFrom',
    props: {
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    type: "TIME",
    label: "完工结束时间",
    value: '',
    upKey: 'deliverTimeTo',
    props: {
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    label: "译员ID",
    value: '',
    upKey: 'resourceId',
    props: { clearable : true }
  },
  {
    label: "任务ID",
    value: '',
    upKey: 'taskId',
    props: { clearable : true }
  },
  {
    type: 'SELECT',
    label: '类型',
    value: [],
    upKey: 'types',
    options: [
      { label: 'Share Translator Basic', id: 'Share Translator Basic' },
      { label: 'Proofreader Basic Share', id: 'Proofreader Basic Share' },
      { label: 'Task Dispute Penalty', id: 'Task Dispute Penalty' },
      // { label: 'Cancel Task Penalty', id: 'Cancel Task Penalty' },
      { label: 'Cancel Task Penalty', id: 'Cancel Task Penalty' },
      { label: 'Amount added against dispute', id: 'Amount added against dispute' },
      { label: 'Manual Transaction', id: 'Manual Transaction' },
      { label: 'PM Task Discount', id: 'PM Task Discount' },
      // { label: 'empty', id: 'null' },
    ],
    props: { clearable: true, placeholder: '请选择类型', multiple: true, 'collapse-tags': true,},
    seleProps: { label: 'label', valueName: 'id', }
  },
  {
    type: 'SELECT',
    label: '是否设置译员币种',
    value: '',
    upKey: 'isExistCurrency',
    options: [
      { label: '未设置', id: true },
    ],
    props: { clearable: true, placeholder: '请选择类型'},
    seleProps: { label: 'label', valueName: 'id', }
  },
  {
    type: 'SELECT',
    label: '币种',
    value: [],
    upKey: 'resourceCurrency',
    options: currencyOption(),
    props: {clearable: true, placeholder: '请选择币种', multiple: true, 'collapse-tags': true},
    seleProps: { label: 'label', valueName: 'id'},
  },
  {
    type: 'SELECT',
    label: 'rt公司',
    value: '',
    upKey: 'company',
    options: rtComapny,
    props: {clearable: true, placeholder: '请选择rt公司',},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '是否计算',
    value: '',
    upKey: 'isNoCalculated',
    options: [
      { label: '计算', id: 'false' },
      { label: '不计算', id: 'true' },
    ],
    props: { clearable: true, placeholder: '请选择是否计算'},
    seleProps: { label: 'label', valueName: 'id', }
  },
  {
    type: 'SELECT',
    label: '完工时间是否包含null',
    value: '',
    upKey: 'isNullDeliverTime',
    options: [
      { label: '包含', id: 'true'},
      { label: '不包含', id: 'false' },
    ],
    props: {clearable: true, placeholder: '请选择国内外收入'},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: ' 是否包含测试单',
    value: '',
    upKey: 'existTestCost',
    options: [
      { label: '包含', id: 'true'},
      { label: '不包含', id: 'false' },
    ],
    props: {clearable: true, placeholder: '请选择国内外收入'},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: 'CO单号是否为空',
    value: '',
    upKey: 'isNullCoOrderId',
    options: [
      { label: '为空', id: 'true' },
      { label: '不为空', id: 'false' },
    ],
    props: { clearable: true, placeholder: '请选择CO单号是否为空'},
    seleProps: { label: 'label', valueName: 'id', }
  },
  {
    type: 'SELECT',
    label: '发票主体公司',
    value: [],
    upKey: 'invoiceCompany',
    options: invoiceCompanyList,
    props: { clearable: true, placeholder: '请选择发票主体公司', multiple: true, 'collapse-tags': true},
    seleProps: { label: 'label', valueName: 'id', }
  },
  {
    label: 'co订单号',
    upKey: 'coOrderId',
    value: '',
  },
  orgCfig({
    upKey: 'coTwoOrgId'
  }),
  {
    type: 'SELECT',
    label: '来源类型',
    value: '',
    upKey: 'dataSourceType',
    options: [
      { label: 'co2', id: 'co2' },
      { label: 'mars', id: 'mars' },
      { label: '手动', id: 'manual' },
      { label: 'co3', id: 'co3' },
    ],
    props: { clearable: true, placeholder: '请选择状态' },
    seleProps: { label: 'label', valueName: 'id', }
  },
  {
    type: 'SELECT',
    label: '订单类别',
    value: '',
    upKey: 'categoryId',
    options: orderCategorysOption,
    props: {clearable: true, placeholder: '请选择订单类别' },
    seleProps: { label: 'label', valueName: 'categoryId' },
  },
  {
    type: 'SELECT',
    label: '是否内部译员',
    value: '',
    upKey: 'isCcjkUser',
    options: [
      { label: '是', id: true },
      { label: '不是', id: false },
    ],
    props: { clearable: true, placeholder: '请选择是否内部译员'},
    seleProps: { label: 'label', valueName: 'id', }
  },
  {
    type: 'SELECT',
    label: '是否是原始订单',
    value: '',
    upKey: 'notOriginal',
    options: [
      { label: '是', id: 'false' },
      { label: '不是', id: 'true' },
    ],
    props: { clearable: true, placeholder: '请选择是否内部译员'},
    seleProps: { label: 'label', valueName: 'id', }
  },
])

onBeforeMount(() => {
  rtCompanyListApi().then(rep => {
    let { company } = rep
    rtComapny.value = company.map(e => ({
      label: e,
      id: e,
    }))
  })

  companiesFullEn_nameApi().then((rep: any) => {
    invoiceCompanyList.value = rep.enName.map((name: string) => ({ label: name, id: name}))
  })

  order_categorysListApi().then((rep: any) => {
    orderCategorysOption.value = rep.map((e: any) => ({label: categorysFunc()[e.category] + '-' + e.name, categoryId: e.id}))
  })
})

const searchForm = ref()
const searchHandle = (params: any) => {
  searchForm.value.dataObj.financeStationName = ''
  fetchData({
    query: params
  })
}
let calculData = computed(() => {
  return MI_tableData.value.map(row => {
    let _row = MI_tableData.value.find(_row => {
      if(
          _row.id !== row.id && 
          _row.resourceId === row.resourceId &&
          _row.taskId === row.taskId &&
          _row.credit === row.credit &&
          dayjs(_row.paymentTime).format('YYYY-MM-DD') == dayjs(row.paymentTime).format('YYYY-MM-DD')
        ){
        return true
      }
    })
    if(_row){
      row.remark = true
    }
    return row
  })
})

// 跳转处理
onActivated(async () => {
  
    // 订单类别报表跳转
  if(route.query.categoryId){
    searchForm.value.resetForm()
    Object.assign(
      searchForm.value.dataObj,
      route.query,
      {categoryId: parseInt(route.query.categoryId as string)}
    )
    searchForm.value.submitHandle()
    return
  }
  // 收入成本页面跳转
  if(route.query.resourceCurrency){
    searchForm.value.resetForm()
    Object.assign(
      searchForm.value.dataObj,
      route.query
    )
    searchForm.value.submitHandle()
    return
  }
  // 内部交易页面跳转
  if(route.query.company){
    searchForm.value.resetForm()
    Object.assign(
      searchForm.value.dataObj,
      route.query
    )
    companiesEn_nameApi({companyId: route.query.companyId as string}).then((rep: any) => {
      // invoiceCompanyList.value = rep.enName.map((name: string) => ({ label: name, id: name}))
      searchForm.value.dataObj.invoiceCompany = rep.enName
      searchForm.value.submitHandle()
    })
    return
  }
  // 语言
  if(route.query.financeStationName){
    searchForm.value.resetForm()
    Object.assign(
      searchForm.value.dataObj,
      route.query
    ),
    fetchData({ query: {...route.query} })
    return
  }

  // 点击应付账款的增加跳转到成本页
  if(route.query.ids){
    searchForm.value.resetForm()
    Object.assign(
      searchForm.value.dataObj,
      {ids:route.query.ids?JSON.parse(route.query.ids as string):[]}
    )
    searchForm.value.submitHandle()
    return
  }
  searchForm.value.submitHandle()
})

// 添加
const addFg = ref(false)
const addConfig: any = ref([
  {
    label: "Transaction_id",
    value: '',
    upKey: 'transactionId',
    props: { }
  },
  {
    label: "订单单号",
    value: '',
    upKey: 'taskId',
    props: { }
  },
  {
    label: "Admin邮箱",
    value: '',
    upKey: 'adminEmail',
    props: { }
  },
  {
    label: "译员邮箱",
    value: '',
    upKey: 'resourceEmail',
    props: { }
  },
  {
    label: "收入",
    value: '',
    upKey: 'credit',
    props: { }
  },
  {
    label: "提现",
    value: '',
    upKey: 'debit',
    props: { }
  },
  // {
  //   label: "交易类型",
  //   value: '',
  //   upKey: 'type',
  //   props: { }
  // },
  {
    label: "余额",
    value: '',
    upKey: 'balance',
    props: { }
  },
  {
    type: 'SELECT',
    label: '公司',
    value: '',
    upKey: 'company',
    options: paymentCompany,
    placeholder: '请选择公司',    
    seleProps: {
      label: 'name',
      valueName: 'name',
    },
    
    props: { placeholder: '请选择公司', clearable: true, 'allow-create': true, filterable : true }
  },
  {
    label: "译员ID",
    value: '',
    upKey: 'resourceId',
    props: { }
  },
  // {
  //   label: "译员类型",
  //   value: '',
  //   upKey: 'resourceType',
  //   props: { }
  // },
  {
    label: "全名",
    value: '',
    upKey: 'fullName',
    props: { }
  },
  {
    label: "CO订单编号",
    value: '',
    upKey: 'coOrderId',
    props: { }
  },
  {
    type: "TIME",
    label: "财务时间",
    value: '',
    upKey: 'paymentTime',
    props: {
      'value-format': 'YYYY-MM-DDTHH:mm:ss'
    }
  },
  {
    type: 'SELECT',
    label: '类型',
    value: 'Manual Transaction',
    upKey: 'type',
    options: [
      { label: 'Share Translator Basic', id: 'Share Translator Basic' },
      { label: 'Proofreader Basic Share', id: 'Proofreader Basic Share' },
      { label: 'Task Dispute Penalty', id: 'Task Dispute Penalty' },
      { label: 'Cancel Task Penalty', id: 'Cancel Task Penalty' },
      { label: 'Amount added against dispute', id: 'Amount added against dispute' },
      { label: 'Manual Transaction', id: 'Manual Transaction' },
      { label: 'PM Task Discount', id: 'PM Task Discount' },
    ],
    props: { clearable: false, placeholder: '请选择类型'},
    seleProps: { label: 'label', valueName: 'id', },
    rule: [{ required: true, message: '请选择类型', trigger: 'change' }],
  },
])
const addHandle = () => {
  MI_modifyForm({type: 'Manual Transaction'}, addConfig, addFg, async(params: any) => {
    await rtAddApi(params)
    ElMessage.success('添加成功')
    addFg.value = false
    fetchData(MI_params)
  })
}
// 修改
const editFg = ref(false)
const editConfig: any = ref([
  ...addConfig.value,
  {
    type: 'SELECT',
    label: '币种',
    value: '',
    upKey: 'resourceCurrency',
    options: currencyOption(),
    props: {clearable: true, placeholder: '请选择币种',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
])
const modifyHandle = (row: any) => {
  MI_modifyForm(row, editConfig, editFg, async(params: any) => {
    await rtModifyApi({
      ...params,
      id: row.id
    })
    ElMessage.success('修改成功')
    editFg.value = false
    fetchData(MI_params)
  })
}

// 删除
const delHandle = async (row: {id: string}) => {
  try {
    await ElMessageBox.confirm(
      '是否确认删除?',
      'Warning',
      {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }
    )
    MI_identify.value = true
    await rtDelApi({id: row.id},{contentType: 'formData'})
    ElMessage.success('删除成功')
    MI_identify.value = false
    fetchData(MI_params)

  } catch (error) {
    
    MI_identify.value = false

  }
}
// 导出成本
const exportRtHandle = () => {
  ElMessageBox.confirm(
    '请检查导出的参数未搜索条件，默认搜索参数可能会导致导出时间过长',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    MI_identify.value = true
    return exportHandle(exportApi, MI_params.query)
  }).then(() => {
    MI_identify.value = false
  }).catch(() => {
    MI_identify.value = false
  })
}
// 同步公司
const syncCompany=async ()=>{
  loading.value=true
  await rtSyncCompanyApi()
  ElMessage.success('同步成功')
  loading.value=false
}
const formatType = (row: Object, column: any, cellValue: string, index: number)  => {
  switch (cellValue) {
    case 'manual':
      return '手动'
    case 'mars':
      return 'mars'
    case 'co2':
      return 'co2'
  
    default:
      return cellValue
  }
}
const handleSelectionChange=(val:any)=>{
	idList.value=val.map((el:any)=>el.id)
}
const modifyPaymentTime=()=>{
	if(!paymentTime.value){
		ElMessage.warning("请选择时间")
		return
	}
	rtBatchApi({idList:idList.value,paymentTime:dayjs(paymentTime.value).format("YYYY-MM-DD")}).then(()=>{
		ElMessage.success('修改成功')
    showTimeVisiable.value=false
    fetchData(MI_params)
	})
}
// 是否计算
const calculFg = ref<boolean>(false)
const calculConfig = ref([
  {
    type: 'SELECT',
    label: '计算类型',
    value: '',
    upKey: 'isNoCalculated',
    options: [
      {
        label: '不计算',
        id: true,
      },
      {
        label: '计算',
        id: false
      }
    ],
    rule: [
      { required: true, message: '计算类型不能为空', trigger: 'change' },
    ],
    props: {clearable: true, placeholder: '请选择计算类型',},
    seleProps: { }
  },
])
const uncalculate = () => {
  if(idList.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  MI_modifyForm({}, calculConfig, calculFg, async(params: any) => {
    await calculatedApi({idList: idList.value, ...params})
    ElMessage.success('成功')
    calculFg.value = false
    fetchData(MI_params)
  })
}
// 同步是否为内部译员
const syncTranslatorFg = ref<false>(false)
const syncTranslatorConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: [],
    upKey: '_date',
    upProps: {startKey: 'startDate', endKey: 'endDate'},
    rule: [{ required: true, message: '请选择日期', trigger: 'change' }],
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD',
      clearable: false,
    },
  },
])
const syncTranslator = () => {
  MI_modifyForm({}, syncTranslatorConfig, syncTranslatorFg, async (params: any) => {
    await update_is_ccjk_userApi({
      type: 'RT',
      startDate: params.startDate, 
      endDate: params.endDate, 
    }, { contentType: 'formData'})

    ElMessage.success('成功')
    syncTranslatorFg.value = false
    fetchData(MI_params)
  })
}


// 手动同步
const syncFg = ref<boolean>(false)
const syncConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: '',
    upKey: 'syncDate',
    rule: [{ required: true, message: '请选择日期', trigger: 'change' }],
    props: { 'value-format': 'YYYY-MM-DD', clearable: false, },
  },
])
const syncHandle = () => {
  MI_modifyForm({}, syncConfig, syncFg, async (params: object) => {
    await sync_rtApi(params, {contentType: 'formData'})
    ElMessage.success('同步成功')
    syncFg.value = false
    fetchData(MI_params)
  })
}
// ----------------
const tableRowClassName = ({row, rowIndex}: any) => {
  
  if (row.remark == true) {
    return 'warning-row'
  }
  if (row.dataSourceType === 'manual' ) {
    return 'manualRow'
  }
  return ''
}

expose({
  searchForm
})

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "成本" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              ref_key: "searchForm",
              ref: searchForm
            }, {
          initSearch: false,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, !props.readTableOnly]
    ]),
    (!props.readTableOnly)
      ? (_openBlock(), _createBlock(_component_el_space, { key: 0 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "mt-10 mb-10",
              type: "primary",
              onClick: addHandle
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })), [
              [_directive_permission, 'Write']
            ]),
            _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: "请先搜索，再导出",
              placement: "top-end"
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (exportRtHandle()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'Export']
                ])
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "mt-10 mb-10",
              loading: _unref(loading),
              disabled: _unref(loading) || true,
              onClick: syncCompany
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["loading", "disabled"])), [
              [_directive_permission, 'Write']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "mt-10 mb-10",
              onClick: syncTranslator
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })), [
              [_directive_permission, 'Write']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "mt-10 mb-10",
              disabled: !idList.value.length,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showTimeVisiable.value=true))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["disabled"])), [
              [_directive_permission, 'Write']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "mt-10 mb-10",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (uncalculate()))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })), [
              [_directive_permission, 'Write']
            ]),
            _withDirectives(_createVNode(_component_TheUpBtn, {
              onUpSuccess: _cache[3] || (_cache[3] = ($event: any) => (_unref(fetchData)(_unref(MI_params)))),
              upText: '导入不计算表',
              upFetch: _unref(import_no_calculatedApi),
              upParams: {},
              showBtn: true
            }, null, 8, ["upFetch"]), [
              [_directive_permission, 'Create']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (syncHandle())),
              type: "primary",
              plain: ""
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })), [
              [_directive_permission, 'Write']
            ]),
            _withDirectives(_createVNode(_component_TheUpBtn, {
              onUpSuccess: _cache[5] || (_cache[5] = ($event: any) => (_unref(fetchData)(_unref(MI_params)))),
              upText: '临时导入',
              upFetch: _unref(rtImportApi),
              upParams: {},
              showBtn: true
            }, null, 8, ["upFetch"]), [
              [_directive_permission, 'Create']
            ]),
            _createVNode(_component_el_popover, {
              placement: "bottom",
              width: 400,
              trigger: "hover"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, { plain: "" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_divider, null, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(calculData),
      "max-height": _unref(MI_height) -50 + 'px',
      onSelectionChange: handleSelectionChange,
      "row-class-name": tableRowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          label: "co订单号",
          prop: "coOrderId",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "ID",
          prop: "id",
          width: "90"
        }),
        _createVNode(_component_el_table_column, {
          label: "译员ID",
          prop: "resourceId"
        }),
        _createVNode(_component_el_table_column, {
          label: "是否内部译员",
          prop: "isCcjkUser",
          width: "115",
          "show-overflow-tooltip": "",
          formatter: (row) => row.isCcjkUser === true ? '是' : '否'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "任务Id",
          prop: "taskId",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "是否不计算",
          prop: "isNoCalculated"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.isNoCalculated ? '不计算': '计算'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "译员名字",
          prop: "fullName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "译员币种",
          prop: "resourceCurrency",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "类型",
          prop: "type",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "借方",
          prop: "debit",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "贷方",
          prop: "credit",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "汇率",
          prop: "rate",
          width: "90",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          label: "本位币",
          prop: "basicCurrency",
          width: "110",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "余额时间",
          prop: "paymentTime",
          width: "100",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          prop: "dateCreated",
          width: "100",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "withdrawalStatus"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", null, [
              (row.withdrawalStatus === 'Paid')
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, "支付"))
                : _createCommentVNode("", true),
              (row.withdrawalStatus === 'un-paid')
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, "未支付"))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "company",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "数据来源",
          prop: "dataSourceType",
          formatter: formatType
        }),
        (!props.readTableOnly)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "操作",
              width: "120"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      onClick: ($event: any) => (modifyHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'Write']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      type: "danger",
                      onClick: ($event: any) => (delHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'Delete']
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_15, "当前选中了" + _toDisplayString(idList.value.length) + "行数据", 1),
      _createVNode(_component_el_pagination, {
        small: "",
        background: "",
        total: _unref(MI_total),
        currentPage: _unref(page),
        "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
        "page-size": _unref(size),
        "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
        class: "mb-5 mt-5",
        "page-sizes": [10, 30, 50, 100, 500, 1000],
        layout: "sizes, prev, pager, next, total, jumper",
        onCurrentChange: _unref(MI_pageChange),
        onSizeChange: _unref(MI_sizeChange)
      }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "添加",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改",
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editFg).value = $event))
    }, {
      default: _withCtx(() => [
        (editFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: editConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改财务日期",
      modelValue: showTimeVisiable.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showTimeVisiable).value = $event)),
      width: 300
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (showTimeVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: modifyPaymentTime
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_date_picker, {
          modelValue: paymentTime.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((paymentTime).value = $event)),
          type: "date",
          placeholder: "选择时间"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: calculFg.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((calculFg).value = $event)),
      title: "是否计算"
    }, {
      default: _withCtx(() => [
        (calculFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: calculConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "同步是否为内部译员",
      modelValue: syncTranslatorFg.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((syncTranslatorFg).value = $event))
    }, {
      default: _withCtx(() => [
        (syncTranslatorFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: syncTranslatorConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "手动同步",
      modelValue: syncFg.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((syncFg).value = $event))
    }, {
      default: _withCtx(() => [
        (syncFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: syncConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})